// extracted by mini-css-extract-plugin
module.exports = {"trailer":"iN","imgWrapper":"iO","thumbnail":"iP","isRental":"iQ","playWrapper":"iR","playImg":"iS","title":"iT","iconWrapper":"iU","navArrow":"iV"};